
import { Component, Vue, Prop } from "nuxt-property-decorator";
@Component
export default class GroupDatiVendita extends Vue {
  @Prop() data!: any;
}
